export class Newsletter {
    email: string;
    firstName: string;
    lastName: string;
}


// WEBPACK FOOTER //
// ./src/app/feature/external/newsletter.ts